var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var AppContextType;
(function (AppContextType) {
    AppContextType["WIDGET_CONTEXT_TYPE"] = "embed_grid";
    AppContextType["EMBED_CONTEXT_TYPE"] = "embed_player";
    AppContextType["EMBED_STORYBLOCK_CONTEXT_TYPE"] = "embed_storyblock";
    AppContextType["EMBED_STORYLINK_CONTEXT_TYPE"] = "embed_storylink";
    AppContextType["EMBED_CHANNEL_BUTTON_CONTEXT_TYPE"] = "embed_channel_button";
    AppContextType["VIDEO_DETAIL_CONTEXT_TYPE"] = "video_detail_player";
    AppContextType["DISCOVER_CONTEXT_TYPE"] = "discover_player";
    AppContextType["CHANNEL_CONTEXT_TYPE"] = "channel_player";
    AppContextType["HASHTAG_CONTEXT_TYPE"] = "hashtag_player";
})(AppContextType || (AppContextType = {}));
export var Context;
(function (Context) {
    Context["CONTEXT_PUBLISHER"] = "publisher";
    Context["CONTEXT_DISCOVER"] = "discover";
    Context["CONTEXT_CHANNEL"] = "channel";
    Context["CONTEXT_HASHTAG"] = "hashtag";
    Context["CONTEXT_PLAYLIST"] = "playlist";
    Context["CONTEXT_PLAYLIST_COLLECTION"] = "playlist_collection";
    Context["CONTEXT_VIDEO_DETAIL"] = "video_detail";
})(Context || (Context = {}));
export const DESKTOP_MEDIAQUERY = 'min-width: 1024px'; // 690px // 376px
export const TABLET_MEDIAQUERY = 'min-width: 690px'; // 690px // 376px
export const FEED_TYPE_USER_TIMELINE = 'user_timeline';
export const contextUrl = ({ appContext, }) => {
    const { appContextType, username, tag, subdomain } = appContext;
    switch (appContextType) {
        case AppContextType.CHANNEL_CONTEXT_TYPE: {
            if (subdomain) {
                return ['/'];
            }
            return ['/[username]', `/${username}`];
        }
        case AppContextType.HASHTAG_CONTEXT_TYPE: {
            return ['/hashtags/[tag]', `/hashtags/${tag}`];
        }
        case AppContextType.VIDEO_DETAIL_CONTEXT_TYPE:
        case AppContextType.DISCOVER_CONTEXT_TYPE: {
            return ['/'];
        }
        default:
            return;
    }
};
export const displayVideoUrl = ({ video, appContext, }) => {
    var _a, _b, _c, _d, _e;
    const _f = appContext || {}, { appContextType } = _f, rest = __rest(_f, ["appContextType"]);
    const host = process.env.PWA_HOST || '';
    let href = '';
    let path = '';
    switch (appContextType) {
        case AppContextType.CHANNEL_CONTEXT_TYPE: {
            const { username, subdomain } = rest;
            href = subdomain ? '/videos/[videoId]' : '/[username]/videos/[videoId]';
            if (subdomain) {
                path = `/videos/${(_a = video === null || video === void 0 ? void 0 : video.encoded_id) !== null && _a !== void 0 ? _a : ''}`;
            }
            else {
                path = `/${username}/videos/${(_b = video === null || video === void 0 ? void 0 : video.encoded_id) !== null && _b !== void 0 ? _b : ''}`;
            }
            break;
        }
        case AppContextType.HASHTAG_CONTEXT_TYPE: {
            const { tag } = rest;
            href = '/hashtags/[tag]/videos/[videoId]';
            path = `/hashtags/${tag}/videos/${(_c = video === null || video === void 0 ? void 0 : video.encoded_id) !== null && _c !== void 0 ? _c : ''}`;
            break;
        }
        case AppContextType.DISCOVER_CONTEXT_TYPE: {
            href = '/discover/[videoId]';
            path = `/discover/${(_d = video === null || video === void 0 ? void 0 : video.encoded_id) !== null && _d !== void 0 ? _d : ''}`;
            break;
        }
        case AppContextType.VIDEO_DETAIL_CONTEXT_TYPE: {
            href = '/videos/[videoId]';
            path = `/videos/${(_e = video === null || video === void 0 ? void 0 : video.encoded_id) !== null && _e !== void 0 ? _e : ''}`;
            break;
        }
    }
    return [href, host + path];
};
export const channelUrl = ({ video, appContext, }) => {
    if (!video) {
        return '';
    }
    let channelUrl = `/${video.creator.username}`;
    if (!!(appContext === null || appContext === void 0 ? void 0 : appContext.channelId) &&
        appContext.channelId !== video.creator.encoded_id) {
        channelUrl = channelUrl + `?referrer_channel_id=${appContext.channelId}`;
    }
    return channelUrl;
};
export const videoActionClickUrl = ({ video, appContext, }) => {
    var _a, _b;
    const { appContextType } = appContext !== null && appContext !== void 0 ? appContext : {};
    switch (appContextType) {
        case AppContextType.EMBED_CONTEXT_TYPE:
        case AppContextType.WIDGET_CONTEXT_TYPE:
        case AppContextType.EMBED_STORYBLOCK_CONTEXT_TYPE:
        case AppContextType.EMBED_CHANNEL_BUTTON_CONTEXT_TYPE: {
            return (_a = video === null || video === void 0 ? void 0 : video.action_click_url) !== null && _a !== void 0 ? _a : '';
        }
        default: {
            return (_b = video === null || video === void 0 ? void 0 : video.pwa_action_click_url) !== null && _b !== void 0 ? _b : '';
        }
    }
};
export const isDesktop = () => {
    const media = typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia(`only screen and (${DESKTOP_MEDIAQUERY})`);
    return media && media.matches;
};
export const isTablet = () => {
    const media = typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia(`only screen and (${TABLET_MEDIAQUERY})`);
    return media && media.matches;
};
export const trimVideoCaption = ({ video, maxLength = 60, }) => {
    const caption = (video === null || video === void 0 ? void 0 : video.caption) || '';
    if (caption.length > maxLength) {
        return caption.slice(0, maxLength).trim() + '...';
    }
    return caption;
};
export const productsUrl = ({ video }) => {
    return video.products_url;
};
export { default as resizeThumbnailUrl } from './resizeThumbnailUrl';
